import { USER_KEY } from '../constants'
import getSelectedChain from './getSelectedChain'

export default () => {
  const { chainName } = getSelectedChain()
  if (chainName) { return chainName }

  return JSON.parse(localStorage.getItem(USER_KEY) || '{}').chainName
}
